import Papa from "papaparse";
import moment from "moment-timezone";
import config from "./config";
import get from "lodash/get";
import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";

import LoopIcon from "material-ui/svg-icons/av/loop";

import qs from "qs";
import { useRouterHistory } from "react-router";
import createBrowserHistory from "history/lib/createBrowserHistory";
import createHashHistory from "history/lib/createHashHistory";
// const createAppHistory = useRouterHistory(process.env.NODE_ENV === 'production' ?  createBrowserHistory : createHashHistory);
const createAppHistory = useRouterHistory(createBrowserHistory);
export const history = createAppHistory({
  parseQueryString: qs.parse,
  stringifyQuery: q =>
    qs.stringify(q, { arrayFormat: "brackets", encode: false })
});

import UserStore from "./stores/UserStore";
import SystemStatesStore from "./stores/SystemStatesStore";

/* intersperse: Return an array with the separator interspersed between
 * each element of the input array.
 *
 * > _([1,2,3]).intersperse(0)
 * [1,0,2,0,3]
 */
function intersperse(arr, sep) {
  if (arr.length === 0) {
    return [];
  }

  return arr.slice(1).reduce(
    function (xs, x, i) {
      return xs.concat([sep, x]);
    },
    [arr[0]]
  );
}

function parsePriceToCents(raw = "", { locale, currency } = {}) {
  const user = UserStore.getUser() || {};
  currency = currency || user.currency || "usd";
  locale = locale || user.locale || "en-US";

  const separator = formatPrice(0, { locale, currency }).replace(
    /[^\.,]/g,
    ""
  )[0];
  const baseString = raw
    .replace(new RegExp("[^0-9\\" + separator + "]", "g"), "")
    .replace(separator, ".");
  return baseString * (config.fee.zero_decimal.includes(currency) ? 1 : 100);
}

/* Format a single price in cents to $xx.yy format. If an array in the form
 * [[price1, quantity1], [price2, quantity2], ...] is passed, return a string
 * in the format "$xx.yy (xQ), $yy.zz (xQ)" where Q is the quantity of each price.
 * Used for showing multiple prices.
 */
function formatPrice(p = 0, short = false, implicit = false) {
  let currency, locale, accounting;

  if (Math.abs(p) < 0.0001) {
    p = 0; // sometimes rounding bugs
  }

  if (typeof short === "object") {
    let _short = short;
    short = _short.short;
    implicit = _short.implicit;
    currency = _short.currency;
    locale = _short.locale;
    accounting = _short.accounting;
  }

  const user = UserStore.getUser() || {};
  currency = currency || user.currency || "usd";
  locale = locale || user.locale || "en-US";

  let format = p => {
    // Zero-decimal currency
    if (config.fee.zero_decimal.includes(currency)) {
      p *= 100;
      short = true;
    }

    let formatted = (p / 100).toLocaleString(locale, {
      style: "currency",
      currency: currency.toUpperCase(),
      minimumFractionDigits: 2
    });

    if (short) {
      // Strip trailing .00 from price, leaving just $XYZ
      formatted = formatted.replace(/[\.,]00(?:$|\s)/, "");
    }

    if (implicit) {
      // strip preceding CA
      formatted = formatted.replace(/^(-)?(CA|MX)/, "$1");
    }

    if (accounting) {
      if (p < 0) {
        formatted = `(${formatted.replace("-", "")})`;
      }
    }

    return formatted;
  };

  if (Array.isArray(p)) {
    return p
      .map(([price, quantity]) => `${format(price)} (x${quantity})`)
      .join(", ");
  } else {
    return format(p);
  }
}

function formatNumber(n = 0, { locale } = {}) {
  const user = UserStore.getUser() || {};
  locale = locale || user.locale || "en-US";
  return (n || 0).toLocaleString(locale);
}

function formatPercent(n = 0, { locale } = {}) {
  const user = UserStore.getUser() || {};
  locale = locale || user.locale || "en-US";
  return (n || 0).toLocaleString(locale, {
    style: "percent",
    maximumFractionDigits: 4
  });
}

// http://stackoverflow.com/questions/14522667/how-to-configure-flot-to-draw-missing-time-series-on-y-axis-at-point-zero
/* helper function to find date differences*/
function dateDiff(d1, d2) {
  return Math.floor((d2 - d1) / (1000 * 60 * 60 * 24));
}
function fillMissingDays(data, makeDates, zeroLength) {
  var i,
    j,
    startDay = data[0][0],
    newData = [data[0]];

  if (typeof zeroLength === "undefined") {
    zeroLength = 1;
  }

  for (i = 1; i < data.length; i++) {
    var diff = dateDiff(data[i - 1][0], data[i][0]);
    var startDate = new Date(data[i - 1][0]);
    if (diff > 1) {
      for (j = 0; j < diff - 1; j++) {
        var fillDate = new Date(startDate).setDate(
          startDate.getDate() + (j + 1)
        );
        newData.push(
          [fillDate]
            .concat(Array(zeroLength).fill(0))
            .concat(data[i - 1].slice(1 + zeroLength))
        );
      }
    }
    newData.push(data[i]);
  }

  if (makeDates) {
    return newData.map(function (r) {
      r[0] = new Date(r[0]);
      return r;
    });
  } else {
    return newData;
  }
}
function fillMissingDaysNew(
  data,
  dateKey = "date",
  replacements = {},
  options = {}
) {
  let diffFunction = options.diffFunction || dateDiff,
    cloneAll = options.cloneAll || false;

  let newData = data.length ? [data[0]] : [];

  for (let i = 1; i < data.length; i++) {
    let diff = diffFunction(get(data[i - 1], dateKey), get(data[i], dateKey)),
      startDate = get(data[i - 1], dateKey);

    if (diff > 1) {
      for (let j = 0; j < diff - 1; j++) {
        let fillDate = new Date(startDate);
        fillDate.setDate(startDate.getDate() + (j + 1));

        let fillValue = cloneDeep(data[i - 1].value).map((v, valueIndex) => {
          if (!cloneAll && replacements[valueIndex] !== "clone") {
            v.result = replacements.default || 0;
          }
          return v;
        });

        newData.push(set({ value: fillValue }, dateKey, fillDate));
      }
    }
    newData.push(data[i]);
  }

  return newData;
}

function makeCsv(data) {
  return "\uFEFF" + Papa.unparse(data);
}

function clientSideDownload(filename, mimeType, content) {
  let data, link;

  data = "data:" + mimeType + ";charset=utf-8," + encodeURIComponent(content);

  link = document.createElement("a");
  link.setAttribute("href", data);
  link.setAttribute("download", filename);

  // Firefox requires an element to actually be mounted on the DOM in order to be clickable.
  document.getElementById("loader").appendChild(link);

  link.click();
}

function formatSubscriptionStatus(subscription) {
  if (subscription.status === "active") {
    var term = subscription.should_autorenew ? "Renews" : "Expires";
    return `${term} ${moment(subscription.renewal_date).format("LL")}`;
  } else {
    return `Expired ${moment(subscription.expired_date).format("LL")}`;
  }
}

function snakeCase(s = "") {
  return s
    .trim()
    .replace(/[^\w\s]/g, "")
    .toLowerCase()
    .replace(/\s+/g, "_");
}

function unSnakeCase(s = "") {
  return s.toLowerCase().replace(/_/g, " ");
}

function capitalize(s) {
  return s && s[0].toUpperCase() + s.slice(1);
}

// SYNC WITH FRONTEND
function applyCoupon(subitem, price, item, coupon, appSettings) {
  let originalPrice = price,
    isVolumeDiscounted = false,
    rawTotal,
    fee;

  // If no price (e.g. an empty inline donation)
  if (!price) {
    price = 0;
  }

  if (!coupon) {
    coupon = {};
  }

  // Apply volume price - find the highest minimum quantity that the current order matches
  // Note: For quantity=1 when a sale price is enabled, we use the sale price instead.
  if (
    item &&
    item.volume_price_enabled &&
    !(item.sale_price && subitem.quantity === 1)
  ) {
    let discount = { minimum_quantity: 0, price: price };
    item.volume_price.forEach(potentialDiscount => {
      if (
        subitem.quantity >= potentialDiscount.minimum_quantity &&
        potentialDiscount.minimum_quantity > discount.minimum_quantity
      ) {
        discount = potentialDiscount;
      }
    });
    price = discount.price;
    isVolumeDiscounted = true;
  }

  // Apply sale price
  if (item && item.sale_price && price === item.sale_price) {
    originalPrice = item.price;
  }

  // "Transform" cents_off with max_quantity=1 to cents_off_item
  if (coupon.cents_off && coupon.max_quantity === 1) {
    coupon.cents_off_item = coupon.cents_off;
    delete coupon.cents_off;
  }

  // Apply percent off / set_price discount, including restricting by quantity
  let percentToDiscount = 1,
    discountedPrice = coupon.set_price
      ? coupon.set_price
      : price - price * ((coupon.percent_off || 0) / 100);
  if (coupon.cents_off_item) {
    discountedPrice -= coupon.cents_off_item;
  }
  discountedPrice = Math.max(0, discountedPrice);
  if (coupon.max_quantity && subitem.quantity > coupon.max_quantity) {
    percentToDiscount = coupon.max_quantity / subitem.quantity;
    price = [
      [discountedPrice, coupon.max_quantity],
      [price, subitem.quantity - coupon.max_quantity]
    ];
  } else {
    price = discountedPrice;
  }

  rawTotal = Array.isArray(price)
    ? price.reduce((total, p) => total + p[0] * p[1], 0)
    : price * (subitem.quantity === 0 ? 0 : subitem.quantity || 1);

  // Calculate cents_off
  if (coupon.cents_off) {
    rawTotal = Math.max(0, rawTotal - coupon.cents_off);
  }

  // Don't show an "original price" because the cents_off discount applies to the total
  if (
    (!coupon.percent_off && !coupon.cents_off_item && !isVolumeDiscounted) ||
    originalPrice === price
  ) {
    originalPrice = undefined;
  }

  // Calculate tax -- FEE NOT INCLUDED AS PART OF IT
  let tax = 0;
  if (appSettings.tax_at_box_office && appSettings.tax_percent) {
    let type = subitem.pass_bucket
      ? "pass"
      : subitem.ticket_bucket
      ? "ticket"
      : subitem.item_bucket
      ? "item"
      : "";
    if (item.code === "donation") {
      type = "donation";
    }

    if (appSettings.tax_for.indexOf(type) !== -1) {
      // Inject on a per-item basis to match ledger style rounding.
      tax =
        subitem.quantity *
        Math.round(appSettings.tax_percent * (rawTotal / subitem.quantity));
      rawTotal += tax;
    }
  }

  // Calculate fee -- Sundance only for now
  if (appSettings.fee_at_box_office) {
    // Calculate fee by summing for each i=0...quantity, to match Ledger-style rounding.
    let calculated = 0;
    for (let i = 0; i < subitem.quantity; i++) {
      // Calculate the price of this numbered item. If price is an array,
      // the array is in the format [[price, quantity], ...]. We want to
      // find the price for the i-th item, so we need to sum the quantities
      // of the items in the array until we reach the i-th item.
      let itemPrice = price;
      if (Array.isArray(price)) {
        let quantitySum = 0;
        for (let j = 0; j < price.length; j++) {
          quantitySum += price[j][1];
          if (quantitySum > i) {
            itemPrice = price[j][0];
            break;
          }
        }
      }

      let piece;
      if (appSettings.pricing_plan === "sundance") {
        piece =
          itemPrice * 0.035 + (subitem.ticket_bucket && itemPrice > 0 ? 35 : 0);
      } else if (appSettings.pricing_plan === "cphdox") {
        piece =
          (subitem.ticket_bucket && itemPrice > 0 ? 1000 : 0);
      } else {
        // FIXME: Unsupported except for Sundance for now
        piece = NaN;
      }

      calculated += Math.round(
        (piece * (100 - appSettings.absorb_fee_percent)) / 100
      );
    }
    fee = calculated;
    rawTotal += fee;
  }

  let total = rawTotal;

  return { originalPrice, price, fee, tax, total };
}
// SYNC

function makeFilmDetailString(details) {
  let detailString = [
    details.runtime && `${details.runtime} minutes`,
    details.country,
    details.year
  ]
    .filter(x => !!x)
    .join(" | ");
  return detailString;
}

function dashify(str) {
  return str
    .trim()
    .replace(/_/g, "-")
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/\W/g, m => (/[À-ž]/.test(m) ? m : "-"))
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, m => "-")
    .toLowerCase();
}

function makeEventDateRangeLabel(event) {
  let geoAvailability;

  if (event.is_virtual) {
    if (event.geographic_restrictions.length) {
      geoAvailability = `in ${event.geographic_restrictions
        .map(r => formatRegion(r))
        .join(", ")}`;
    } else if (event.geographic_exclusions.length) {
      geoAvailability = `everywhere except ${event.geographic_exclusions
        .map(r => formatRegion(r))
        .join(", ")}`;
    }
    if (!event.is_dated && geoAvailability) {
      return `Available ${geoAvailability}`;
    }
    if (
      !event.is_dated &&
      !event.geographic_restrictions.length &&
      !event.geographic_exclusions.length
    ) {
      return <span>No availability restrictions</span>;
    }
  }

  if (!event.is_dated) return <span>Undated event</span>;
  if (!event.start_time || !event.end_time)
    return <span>Date not yet set</span>;
  const isDifferentTimezone =
    !!event.timezone && moment.tz.guess() !== event.timezone;
  const start = event.start_time._isAMomentObject
    ? event.start_time
    : moment.tz(event.start_time, event.timezone);
  const end = event.end_time._isAMomentObject
    ? event.end_time
    : moment.tz(event.end_time, event.timezone);
  return (
    <span>
      {event.is_virtual ? "Available " : ""}
      {start.twix(end).format({
        showDate: true,
        implicitMinutes: false,
        groupMeridiems: false,
        implicitYear: false
      })}
      {isDifferentTimezone ? ` ${start.format("z")}` : ""} {geoAvailability}
      {event.recurring_event && event.recurring_event.repeats.length ? (
        <LoopIcon
          style={{
            color: "inherit",
            height: "1em",
            verticalAlign: "-2px",
            marginLeft: -4
          }}
        />
      ) : null}
    </span>
  );
}

function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

const POSTAL_PREFIX = "postal-";
function formatRegion(code) {
  const locationData = SystemStatesStore.getLocationData();
  const continent = locationData.continents.find(c => c.code === code);
  if (continent) {
    return continent.name;
  }
  const country = locationData.countries.find(c => c.code === code);
  if (country) {
    return country.name;
  }
  const region = locationData.regions.find(r => r.code === code);
  if (region) {
    return region.name;
  }

  if (code.startsWith(POSTAL_PREFIX)) {
    return code.substring(POSTAL_PREFIX.length);
  }

  return "???";
}

function formatBasedOnQuantity(quantity, singleOption, multipleOption) {
  return quantity === 1 ? singleOption : multipleOption;
}

export {
  intersperse,
  parsePriceToCents,
  formatPrice,
  formatNumber,
  formatPercent,
  fillMissingDays,
  fillMissingDaysNew,
  makeCsv,
  clientSideDownload,
  formatSubscriptionStatus,
  snakeCase,
  unSnakeCase,
  capitalize,
  applyCoupon,
  makeFilmDetailString,
  dashify,
  makeEventDateRangeLabel,
  formatBytes,
  formatRegion,
  formatBasedOnQuantity
};



// WEBPACK FOOTER //
// ./src/app/util.js